import { cn } from '@ngg/storefront-utils';

type Props = {
  title?: string | null;
  name?: string | null;
  setActiveDrawer: (value: string) => void;
  desktopNavigationDrawerOpen: boolean;
  activeDrawer: string;
  setOpen: (value: boolean) => void;
};
export default function OpenDrawerButton({
  setActiveDrawer,
  desktopNavigationDrawerOpen,
  activeDrawer,
  setOpen,
  title,
  name,
}: Props) {
  if (!title) return null;
  return (
    <button
      onClick={(event) => {
        event.preventDefault();
        setActiveDrawer(name || '');
        setOpen(true);
      }}
      className={cn([
        'cursor-pointer whitespace-nowrap uppercase hover:underline',
        name === activeDrawer && desktopNavigationDrawerOpen && 'underline',
      ])}>
      {title}
    </button>
  );
}
